/**
 * WPGraphQL for ACF v2 resolves `select` and `checkbox` fields as lists, even
 * when the field only accepts a single choice. Callers expect a single value.
 */
export function acfFirst<T>(value: ReadonlyArray<T | null> | null | undefined): T | undefined {
  return value?.find((entry): entry is T => entry !== null) ?? undefined;
}

/**
 * WPGraphQL for ACF v2 resolves `post_object`, `relationship` and `page_link`
 * fields as `AcfContentNodeConnection`s. Our queries only select fields on a
 * single concrete type, so pick the first node of that type. urql's
 * `cacheExchange` injects `__typename` into every selection set, so it is
 * always present at runtime.
 */
export function acfNode<
  TNode extends { __typename?: string },
  TName extends NonNullable<TNode['__typename']>,
>(
  connection: { nodes: TNode[] } | null | undefined,
  typename: TName,
): Extract<TNode, { __typename?: TName }> | undefined {
  return connection?.nodes.find(
    (node): node is Extract<TNode, { __typename?: TName }> => node.__typename === typename,
  );
}
